"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _userInfo = require("hub-http/userInfo");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _link = require("../../constants/link");

var _link2 = require("../../utils/link");

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links.linkTypes." + _link.LinkTypes.MEETING + "." + suffix;
};

var getMeetingDisplay = function getMeetingDisplay(meeting, formattedUserName) {
  return meeting.name || _I18n.default.text(i18nKey('defaultName'), {
    user: formattedUserName
  });
};

var MeetingLinkField = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(MeetingLinkField, _PureComponent);

  function MeetingLinkField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MeetingLinkField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MeetingLinkField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.onChange({
        url: value.options.url,
        meetingName: value.options.label
      });
    };

    _this.fetchMeetingLinks = function (_input, callback) {
      _this.props.fetchMeetingsByUsers().then(function (meetingsByUser) {
        var options = meetingsByUser.map(function (user) {
          return {
            text: (0, _link2.formatUserName)(user),
            userId: user.id,
            options: user.meetings.map(function (meeting) {
              return {
                help: meeting.link,
                value: meeting.link,
                userId: meeting.userId,
                text: getMeetingDisplay(meeting, (0, _link2.formatUserName)(user)),
                options: {
                  label: getMeetingDisplay(meeting, (0, _link2.formatUserName)(user)),
                  url: meeting.link
                },
                id: meeting.id
              };
            })
          };
        });

        if (!options.length) {
          options.push({
            text: _I18n.default.text(i18nKey('noMeetingsTitle')),
            disabled: true,
            help: _react.default.createElement(_UILink.default, {
              href: (0, _link2.getSetupMeetingLinkUrl)(),
              external: true
            }, _I18n.default.text(i18nKey('noMeetingsHelp')))
          });
        } else {
          options.sort((0, _link2.getAlphabeticalSortPrioritizingUser)(_this.userId));
        }

        callback(null, {
          options: options
        });
      });
    };

    return _this;
  }

  (0, _createClass2.default)(MeetingLinkField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.userId) {
        this.userId = this.props.userId;
      } else {
        try {
          var _userInfoSync = (0, _userInfo.userInfoSync)(),
              user = _userInfoSync.user;

          this.userId = user.user_id;
        } catch (error) {// DO NOTHING - all this means is that we cannot prioritize
          // the current user in the sorted meeting link list
        }
      }

      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          dropdownClassName = _this$props.dropdownClassName;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey('label')),
        className: "m-top-0"
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        searchable: true,
        filterOptions: true,
        value: url,
        loadOptions: this.fetchMeetingLinks,
        onSelectedOptionChange: this.handleChange,
        placeholder: _I18n.default.text(i18nKey('placeholder'))
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        userId: _propTypes.default.number,
        fetchMeetingsByUsers: _propTypes.default.func.isRequired,
        onChange: _propTypes.default.func.isRequired,
        url: _propTypes.default.string,
        dropdownClassName: _propTypes.default.string
      };
    }
  }]);
  return MeetingLinkField;
}(_react.PureComponent);

exports.default = MeetingLinkField;
module.exports = exports.default;